// extracted by mini-css-extract-plugin
export default {"message":"Alert_message__59FPt"};